<p-dialog header="Title" [visible]="(ui.modalSpinnerVisible$ | async) === true" [draggable]="false" [resizable]="false" [modal]="true" [closable]="false" [showHeader]="false" [styleClass]="'modal-spinner'">
  <div class="p-d-flex p-flex-column p-jc-center p-ai-center" style="height: 100%;">
    <p-progressSpinner class="p-mb-4" [style]="{width: '50px', height: '50px'}"></p-progressSpinner>
    <p>{{ui.modalSpinnerMessage$ | async}}</p>
  </div>
</p-dialog>
